import type { StatusLabels } from '../types/operationDetail';

const DECISION_NAMES = {
  risk: 'Riesgo',
  commercial: 'Gerencia Comercial',
  verification: 'Verificación',
  operations: 'Operaciones',
} as const;

const DECISION_PENDING = 'pending';
const DECISION_APPROVED = 'approved';
const DECISION_REJECTED = 'rejected';

const STATUS_LABELS: StatusLabels = {
  pending: 'Pendiente',
  approved: 'Aprobado',
  rejected: 'Rechazado',
};

export {
  DECISION_APPROVED,
  DECISION_NAMES,
  DECISION_PENDING,
  DECISION_REJECTED,
  STATUS_LABELS,
};
